import { Module } from 'vuex'
import { RootState } from '@/store'
import mutations from '@/store/schedule/mutations'
import { path } from '@/store/schedule/types'
import { mutation } from '@/utils/mutation'
import state, { IScheduleState } from '@/store/schedule/state'

export * from '@/store/schedule/state'

export const store: Module<IScheduleState, RootState> = {
  state,
  mutations: mutation(mutations, path)
}
